

















import Vue from 'vue'

import BasePanel from 'base/components/BasePanel.vue'

import { DragDropAction, DragDropService, DragDropTarget } from '../widgets/base/drag-drop'
import { EventService } from '../../base/services/EventService'
import { WidgetService } from '../widgets/base/widget/WidgetService'
import { WidgetType } from '../widgets/base'
import WidgetPanelSection from './WidgetPanelSection.vue'

export enum WidgetSection {
  layout,
  messages,
  misc,
  status
}

export default Vue.extend({
  components: {
    BasePanel,
    WidgetPanelSection
  },
  data() {
    return {
      isDragging: false,
      disableDeleteDialog: false as boolean | undefined,
      onDragStartCb: undefined as unknown as (action: DragDropAction) => void,
      onDragEndCb: undefined as unknown as (action: DragDropAction) => void,
      dragTarget: undefined as unknown as DragDropTarget
    }
  },
  computed: {
    showDeleteDialog(): boolean {
      return this.isDragging && !this.disableDeleteDialog
    },
    accessDashboardWidgets(): object | any {
      return this.$store.state.user.access.dashboard_widgets
    },
    widgetSections(): object {
        return {
          [WidgetSection.layout]: {
          header: 'Layout',
          widgets: [
            WidgetService.getWidgetSpecification(WidgetType.widgetContainer),
            WidgetService.getWidgetSpecification(WidgetType.spacer),
            WidgetService.getWidgetSpecification(WidgetType.header),
          ]
        },
        [WidgetSection.status]: {
          header: 'Status',
          widgets: [
            this.accessDashboardWidgets.status_compact ? WidgetService.getWidgetSpecification(WidgetType.statusCompact) : null,
            this.accessDashboardWidgets.status_detail ? WidgetService.getWidgetSpecification(WidgetType.statusDetail) : null,
            this.accessDashboardWidgets.vehicle_status ? WidgetService.getWidgetSpecification(WidgetType.vehicleStatus) : null
            // WidgetService.getWidgetSpecification(WidgetType.crewtarget)
          ]
        },
        [WidgetSection.messages]: {
          header: 'Meldungen',
          widgets: [
            // WidgetService.getWidgetSpecification(WidgetType.activity),
            // WidgetService.getWidgetSpecification(WidgetType.report),
            this.accessDashboardWidgets.alarm_informations ? WidgetService.getWidgetSpecification(WidgetType.alarmInformations) : null,
            this.accessDashboardWidgets.vehicle_status_history ? WidgetService.getWidgetSpecification(WidgetType.vehicleStatusHistory) : null,
            this.accessDashboardWidgets.messages ? WidgetService.getWidgetSpecification(WidgetType.messages) : null,
            this.accessDashboardWidgets.direct_messages ? WidgetService.getWidgetSpecification(WidgetType.directMessages) : null,
            this.accessDashboardWidgets.messenger ? WidgetService.getWidgetSpecification(WidgetType.messenger) : null
          ]
        },
        [WidgetSection.misc]: {
          header: 'Sonstiges',
          widgets: [
            this.accessDashboardWidgets.countdown ? WidgetService.getWidgetSpecification(WidgetType.countdown) : null,
            this.accessDashboardWidgets.iframe ? WidgetService.getWidgetSpecification(WidgetType.iframe) : null,
            this.accessDashboardWidgets.map ? WidgetService.getWidgetSpecification(WidgetType.map) : null
          ]
        }
      }
    }
  },
  mounted() {
    EventService.$on('drag-drop-service-start-drag', this.onDragStartCb = this.onDragStart.bind(this))
    EventService.$on('drag-drop-service-end-drag', this.onDragEndCb = this.onDragEnd.bind(this))

    this.dragTarget = new DragDropTarget(this.$refs.deleteDialog, true)
      .allow('*')
      .onDragEnter(this.onDeleteZoneEnter.bind(this))
      .onDragLeave(this.onDeleteZoneLeave.bind(this))
      .onDrop(this.onDeleteZoneDrop.bind(this))
      .isLateInitializer(true)
    DragDropService.registerDragTarget(this.dragTarget!)
  },
  beforeDestroy() {
    if (this.onDragStartCb) {
      EventService.$off('drag-drop-service-start-drag', this.onDragStartCb)
    }
    if (this.onDragEndCb) {
      EventService.$off('drag-drop-service-end-drag', this.onDragEndCb)
    }
    if (this.dragTarget) {
      DragDropService.unregisterDragTarget(this.dragTarget!)
    }
  },
  methods: {
    onDragStart(action: DragDropAction) {
      this.disableDeleteDialog = action.getWidget().isTemplate
      this.isDragging = true
    },
    onDragEnd(action: DragDropAction) {
      this.disableDeleteDialog = false
      this.isDragging = false
    },
    onDeleteZoneEnter(action: DragDropAction) {
      EventService.$emit('delete-zone-enter')
    },
    onDeleteZoneLeave(action: DragDropAction) {
      EventService.$emit('delete-zone-leave')
    },
    onDeleteZoneDrop(action: DragDropAction) {
      EventService.$emit('delete-zone-drop', action.getWidget())
    }
  }
})
